
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import { preloadCss, preloadScript, publicUrl } from './utils/url';
import { isFeatureEnabled } from './utils/Features';
import { initBasketEditLinks, isBasketPage } from './basket/basketEditLinks';
// import reportWebVitals from './reportWebVitals';

// without file name
var documentLocation = String(document.currentScript.src).split('/').slice(0, -1).join('/') + '/';
   let mainCssUrl = documentLocation + "static/css/app.css?" + BUILD_TIMESTAMP;
    console.log({
        mainCssUrl
    });
// preloadCss('https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&display=swap');
preloadCss('https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&family=Playfair+Display:ital,wght@0,400..900;1,400..900&display=swap');
preloadCss(mainCssUrl);

// MYB-121: inject the basket <-> configurator integration on every page so it
// covers the full basket and the site-wide offcanvas mini-cart. The basket page
// itself must not mount the configurator app.
const basketFeatureEnabled = isFeatureEnabled();
if (basketFeatureEnabled) {
    initBasketEditLinks();
}
if (!(basketFeatureEnabled && isBasketPage())) {
    const root = document.createElement('div');
    root.setAttribute('id', 'root');
    document.body.appendChild(root);

    const rootEl = ReactDOM.createRoot(document.getElementById('root'));
    rootEl.render(<App />);
}

// preloadScript('https://static.sketchfab.com/api/sketchfab-viewer-1.12.1.js').then(() => {
    
    
// }).catch(err => {
//     console.error(err);
// });


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
